import { BaseModel } from "../base.model";

export class RefExpectedBenefit extends BaseModel {
  name: string;
  description: string;
  isPriorityField: boolean;
}
